module.exports = __webpack_public_path__ + "img/upperabs-endomorph-male.6f7e00f9.svg";